<template>
  <div class="beta-decay-neutrino-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>n → p + e⁻ + ν_e | 能量连续谱之谜$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Initial Neutron -->
          <g v-if="!decayed" transform="translate(100, 120)">
             <circle r="12" fill="#888" stroke="#fff" />
             <text x="-5" y="4" fill="#fff" font-size="8">n</text>
          </g>

          <!-- Decay Products -->
          <g v-else>
             <!-- Proton (Fixed) -->
             <g transform="translate(100, 120)">
                <circle r="12" fill="#ff4757" stroke="#fff" />
                <text x="-5" y="4" fill="#fff" font-size="8">p</text>
             </g>
             <!-- Electron (Fast) -->
             <circle :cx="eX" :cy="eY" r="4" fill="#00d2ff" />
             <text :x="eX-2" :y="eY-6" fill="#00d2ff" font-size="6">e⁻</text>
             
             <!-- Neutrino (Ghostly) -->
             <circle :cx="vX" :cy="vY" r="2" fill="#2ed573" opacity="0.6" stroke="#fff" stroke-dasharray="1,1" />
             <text :x="vX-2" :y="vY-6" fill="#2ed573" font-size="6">ν_e</text>
          </g>

          <!-- Energy spectrum display -->
          <path :d="spectrumPath" fill="none" stroke="#ffd700" stroke-width="1.5" />
          <line :x1="80 + (energyShare/100)*100" y1="200" :x2="80 + (energyShare/100)*100" y2="220" stroke="#00d2ff" />
          
          <text x="80" y="235" fill="#888" font-size="7">电子动能分布 (中微子带走了剩下的能量)</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>观测结果: {{ decayed ? '能量平衡 (由中微子补足)' : '衰变前' }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <el-button type="primary" size="mini" @click="startDecay" :disabled="decayed">观测衰变</el-button>
          <el-button size="mini" @click="reset">重置</el-button>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>在 Beta 衰变的研究早期，物理学家发现由于释放出的电子动能是连续分布的，似乎违反了能量守恒定律。泡利预言存在一种质量极小、不带电、极难探测的粒子——**中微子**，它带走了剩余的能量。Beta 衰变的本质是弱相互作用导致的夸克转变（d夸克变u夸克）。这是人类认识弱力及微观世界基本粒子的重要里程碑。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BetaDecayNeutrinoViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      decayed: false,
      eX: 100, eY: 120,
      vX: 100, vY: 120,
      energyShare: 40,
      t: 0,
      timer: null
    }
  },
  computed: {
    spectrumPath() {
       let pts = [];
       for (let x = 0; x <= 100; x += 5) {
          let y = 220 - (x * (100 - x) * 0.015);
          pts.push(`${80 + x},${y}`);
       }
       return "M " + pts.join(" L ");
    }
  },
  methods: {
    startDecay() {
       this.decayed = true;
       this.energyShare = 30 + Math.random() * 60;
       this.animate();
    },
    animate() {
       if (!this.decayed) return;
       this.t++;
       let speedE = this.energyShare * 0.1;
       let speedV = (100 - this.energyShare) * 0.1;

       this.eX += speedE;
       this.eY += (Math.random() - 0.5) * 5;
       
       this.vX += Math.cos(2) * speedV;
       this.vY += Math.sin(2) * speedV;

       this.timer = requestAnimationFrame(this.animate);
    },
    reset() {
       this.decayed = false;
       this.eX = 100; this.eY = 120;
       this.vX = 100; this.vY = 120;
       cancelAnimationFrame(this.timer);
    }
  },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.beta-decay-neutrino-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(46, 213, 115, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
